import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';

export const DefaultCheckbox= withStyles({
  root: {
    fontSize: '12px',
    width: '50px',
    '&$checked': {
      color: '#009688 !important',
    },
  },
  checked: {
    color: '#009688 !important',
  },
})(Checkbox);